export default "__VITE_ASSET__DYGD8TiM__"